const ErrorType = {
  PAGE_NOT_FOUND: 'PAGE_NOT_FOUND',
  OTHER: 'OTHER',
};

/**
 * An error whose message was written for the user and is safe to show as-is.
 *
 * Anything else reaching the same catch — an internal failure, a library throw — is not,
 * so UI that shows a curated reason keys off this type rather than off `error.message`.
 * The flag carries the check instead of `instanceof` so it survives transpilation and
 * still holds for an error crossing a bundle boundary.
 */
class UserFacingError extends Error {
  constructor(message) {
    super(message);
    this.name = 'UserFacingError';
    this.isUserFacing = true;
  }
}

/**
 * Whether an error carries a message meant for the user.
 *
 * @param {Error} error - The caught error.
 * @returns {boolean} True when its message is safe to show.
 */
const isUserFacingError = (error) => error?.isUserFacing === true;

export {
  ErrorType,
  UserFacingError,
  isUserFacingError,
};
